export class ProfileUser {
    email: string;
    username: string;
    active: boolean;
    subject: string;
    firstName: string;
    lastName: string;
    middleName: string;
    fullName: string;
}